import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PublicTeamDetailPage from './TeamDetailPage'

const PublicTeamsOverviewPage = () => (
    <Routes>
        <Route path="/:teamId" element={<PublicTeamDetailPage />} />
    </Routes>
)

export default PublicTeamsOverviewPage
